export default "__VITE_ASSET__DYCDgW9C__"